import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Container } from '../Container'
import {
  twDefaultInitialWizardFormValues,
  NoEmailScheduleServiceFormMultiStep,
} from '../Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep'
import { StarsAndRatings } from '../SEMPage/StarsAndRatings'
import { useQueryParam } from '../../hooks/useQueryParam'
import backgroundImage from '../../../public/img/nubrakes-van-house-800-num.jpg'

export const HomeScheduleServiceFormHeader: React.FC<{
  title: string
  rating: string
  reviewCount: number
  subheading: string
}> = ({ title, rating, reviewCount, subheading }) => {
  const query = useQueryParam()

  return (
    <section className="relative">
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          zIndex: -100,
          top: 0,
          left: 0,
        }}
      >
        <div className="py-8 flex flex-col justify-center align-center w-full h-full min-h-[60vh] relative">
          <Image
            src={backgroundImage}
            layout="fill"
            objectFit="cover"
            objectPosition={'bottom center'}
            priority={true}
            alt="NuBrakes Mobile Repair"
          />
          <div
            style={{
              backgroundColor: 'rgba(0,0,0,.75)',
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 1,
              top: 0,
              left: 0,
            }}
          />
        </div>
      </div>
      <Container className="text-center z-10">
        <div className="grid lg:grid-cols-2 gap-4">
          <div className="text-center lg:text-left flex flex-col justify-center">
            <h1 className="text-2xl sm:text-2xl md:text-4xl text-white sm:mb-0">{title}</h1>
            <p style={{ fontSize: 18, marginBottom: 10 }} className="subheading text-white hidden sm:hidden md:block">
              {subheading}
            </p>
            <div
              className="w-auto lg:inline-block hidden mr-auto p-3 text-center"
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.69)',
                borderRadius: 6,
              }}
            >
              <StarsAndRatings />
              <p
                style={{
                  color: '#cbd0d3',
                  lineHeight: 1,
                }}
              >
                {`NuBrakes is rated ${rating}/5 by `}
                <Link href={{ pathname: '/reviews/', query }} prefetch={false}>
                  <a
                    style={{
                      color: '#cbd0d3',
                      textDecoration: 'underline',
                    }}
                  >{`${reviewCount} brake repair customers`}</a>
                </Link>
              </p>
            </div>
          </div>
          <div className="mt-0 md:mt-6">
            <div style={{ backgroundColor: 'white' }} className="flex flex-col p-6 lg:mt-0 text-left">
              <NoEmailScheduleServiceFormMultiStep
                initialValues={{
                  ...twDefaultInitialWizardFormValues,
                  'form-name': 'getQuoteScheduleService',
                }}
              />
            </div>
            <div className="mt-5 block lg:hidden text-center">
              <div
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.69)',
                  borderRadius: 6,
                }}
                className="block px-3 py-2"
              >
                <StarsAndRatings />
                <p
                  style={{
                    color: '#cbd0d3',
                    lineHeight: 1,
                  }}
                >
                  {`NuBrakes is rated ${rating}/5 by `}
                  <Link href={{ pathname: '/reviews/', query }} prefetch={false}>
                    <a
                      style={{
                        color: '#cbd0d3',
                        textDecoration: 'underline',
                      }}
                    >{`${reviewCount} brake repair customers`}</a>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
